(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ona-banner-slider"]) return;
  try {
    
  // Self-contained slick init for banner-top-slider. Replaces the global handler in script.js
  // so it survives Shopify theme-editor section reloads and avoids duplicate arrow appends.
  (function () {
    function initSlider($el) {
      if ($el.hasClass('slick-initialized')) return;
      $el.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        dots: true,
        infinite: true,
        speed: 600,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        autoplaySpeed: 5000,
        cssEase: 'cubic-bezier(0, 0, 0.58, 1)'
      });
      $el.find('.slider-list').addClass('move');
      $el.off('beforeChange.onaBanner').on('beforeChange.onaBanner', function () {
        var $list = $el.find('.slider-list');
        $list.removeClass('move');
        setTimeout(function () { $list.addClass('move'); }, 400);
      });
      var $dots = $el.find('.slick-dots');
      if ($dots.find('.prev-arrow').length === 0) {
        $dots.append('<li class="prev-arrow"></li><li class="next-arrow"></li>');
      }
    }

    function boot(root) {
      if (typeof jQuery === 'undefined' || !jQuery.fn || !jQuery.fn.slick) {
        return setTimeout(function () { boot(root); }, 100);
      }
      var $scope = root ? jQuery(root) : jQuery(document);
      $scope.find('.banner-top-slider').each(function () {
        initSlider(jQuery(this));
      });
    }

    // Single delegated arrow handler (safe to register once; guarded with a flag)
    if (!window.__onaBannerArrowsBound) {
      window.__onaBannerArrowsBound = true;
      jQuery(document).on('click', '.banner-top-slider .slick-dots .prev-arrow', function (e) {
        e.preventDefault();
        jQuery(this).closest('.banner-top-slider').slick('slickPrev');
      });
      jQuery(document).on('click', '.banner-top-slider .slick-dots .next-arrow', function (e) {
        e.preventDefault();
        jQuery(this).closest('.banner-top-slider').slick('slickNext');
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    // Re-init on theme editor section reload
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector('.banner-top-slider')) boot(e.target);
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target) return;
      var el = e.target.querySelector('.banner-top-slider.slick-initialized');
      if (el) jQuery(el).slick('unslick');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ona-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openCartDrawer() {
      // Trigger Horizon's cart-drawer-component open if present
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') { drawer.open(); return; }
      // Fallback: click the cart trigger that normally opens it
      var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      trigger && trigger.click();
    }

    function refreshCartBubble() {
      fetch('/?sections=header-group', { credentials: 'same-origin' })
        .then(r => r.json())
        .then(data => {
          // Horizon's cart-icon subscribes to an updated cart; simplest: just fetch /cart.js and update bubble text
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(r => r.json())
            .then(cart => {
              var bubbleText = document.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count');
              bubbleText.forEach(el => el.textContent = cart.item_count);
              document.querySelectorAll('.cart-bubble').forEach(b => b.classList.toggle('visually-hidden', cart.item_count === 0));
            })
            .catch(() => {});
        })
        .catch(() => {});
    }

    document.querySelectorAll('[data-ona-card]').forEach(function (card) {
      var pills = card.querySelectorAll('[data-card-pill]');
      var variantInput = card.querySelector('[data-card-variant-input]');
      var priceEl = card.querySelector('[data-card-price]');
      var optVal = card.querySelector('[data-card-opt-value]');
      var atc = card.querySelector('[data-card-atc]');
      var form = card.querySelector('[data-card-form]');

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) {
            p.classList.remove('ona-fc__pill--active');
            p.setAttribute('aria-checked', 'false');
          });
          pill.classList.add('ona-fc__pill--active');
          pill.setAttribute('aria-checked', 'true');
          variantInput.value = pill.dataset.variantId;
          // Price intentionally NOT changed here — card shows "from $X" (min price).
          if (optVal) optVal.textContent = pill.dataset.variantTitle;
          var available = pill.dataset.variantAvailable === 'true';
          atc.disabled = !available;
          atc.textContent = available ? 'Add to cart' : 'Sold out';
        });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        atc.classList.add('is-loading');
        var label = atc.textContent;
        atc.textContent = 'Adding…';

        var body = new URLSearchParams();
        body.append('id', variantInput.value);
        body.append('quantity', '1');
        // Request ona_header's section HTML so cart-items-component can morph in the fresh drawer content
        body.append('sections', 'ona_header');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: body,
          credentials: 'same-origin'
        })
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (err) { throw err; }); })
        .then(function (resp) {
          atc.textContent = 'Added ✓';

          // Dispatch cart:update so Horizon's cart-items-component + cart-icon pick up new data
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: resp,
              sourceId: variantInput.value,
              data: {
                source: 'ona-featured-collection',
                sections: resp.sections || {},
                itemCount: resp.item_count
              }
            }
          }));

          // R50: Liquid `{% if %}` was previously inlined here, which is illegal
          // inside `{% javascript %}` (Shopify does not render Liquid inside
          // this tag), so the raw `{%` token broke compiled_assets/scripts.js
          // for the whole theme — symptom: every section's slick init failed.
          // Setting is now exposed via inline <script> above the {% javascript %} block.
          if (window.__onaAutoOpenCart) setTimeout(openCartDrawer, 120);
          setTimeout(function () { atc.textContent = label; atc.classList.remove('is-loading'); }, 1500);
        })
        .catch(function (err) {
          atc.textContent = (err && err.description) ? err.description : 'Error';
          atc.classList.remove('is-loading');
          setTimeout(function () { atc.textContent = label; }, 2000);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ona-featured-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function openCartDrawer() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') return drawer.open();
      var trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      trigger && trigger.click();
    }

    document.querySelectorAll('[data-section-type="ona-featured-product"]').forEach(function (root) {
      var optionSelects = root.querySelectorAll('[data-ona-fp-option]');
      var variantSelect = root.querySelector('[data-ona-fp-id]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-compare]');
      var submit = root.querySelector('[data-ona-fp-atc]');
      var form = root.querySelector('[data-ona-fp-form]');

      function updateVariant() {
        var chosen = Array.from(optionSelects).map(function (s) { return s.value; });
        var match = null;
        Array.from(variantSelect.options).forEach(function (opt) {
          var ok = chosen.every(function (v, i) { return opt.getAttribute('data-option' + (i+1)) === v; });
          if (ok) match = opt;
        });
        if (!match) return;
        variantSelect.value = match.value;
        var available = match.getAttribute('data-available') === 'true';
        submit.disabled = !available;
        submit.textContent = available ? 'Add to cart' : 'Sold out';
        if (priceEl) priceEl.textContent = match.getAttribute('data-price');
        if (compareEl) {
          var cmp = match.getAttribute('data-compare');
          if (cmp && cmp !== '$0.00' && cmp !== match.getAttribute('data-price')) {
            compareEl.textContent = cmp; compareEl.style.display = '';
          } else { compareEl.style.display = 'none'; }
        }
        // Fire event so Appstle recalculates displayed subscription prices for new variant
        form.dispatchEvent(new Event('change', { bubbles: true }));
      }

      optionSelects.forEach(function (s) { s.addEventListener('change', updateVariant); });

      // AJAX add to cart (same flow as featured-collection)
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        submit.classList.add('is-loading');
        var label = submit.textContent;
        submit.textContent = 'Adding…';

        var fd = new FormData(form);
        // Also include sections so cart drawer refreshes
        fd.append('sections', 'ona_header');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd,
          credentials: 'same-origin'
        })
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (err) { throw err; }); })
        .then(function (resp) {
          submit.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: resp,
              sourceId: variantSelect.value,
              data: { source: 'ona-featured-product', sections: resp.sections || {}, itemCount: resp.item_count }
            }
          }));
          // R50: see ona-featured-collection.liquid for context — Liquid is
          // illegal inside {% javascript %} blocks; flag is set via inline <script> above.
          if (window.__onaAutoOpenCart) setTimeout(openCartDrawer, 120);
          setTimeout(function () { submit.textContent = label; submit.classList.remove('is-loading'); }, 1500);
        })
        .catch(function (err) {
          submit.textContent = (err && err.description) ? err.description : 'Error';
          submit.classList.remove('is-loading');
          setTimeout(function () { submit.textContent = label; }, 2000);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ona-header"] && !Shopify.designMode) return;
  try {
    
  // R54: First-paint sync moved to inline <script> right after .wrap-header (no flash on refresh).
  // This block now only handles theme editor reloads via shopify:section:load.
  (function () {
    function sync() {
      var wrap = document.querySelector('.wrap-header');
      if (!wrap) return;
      var header = wrap.closest('header');
      if (!header) return;
      ['has-white-label', 'darkred-color', 'white-logo'].forEach(function (cls) {
        header.classList.toggle(cls, wrap.classList.contains(cls));
      });
    }
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ona-slideshow"] && !Shopify.designMode) return;
  try {
    
  // Init slick on our slideshow. Waits for jQuery+slick to be ready (both loaded with defer).
  (function () {
    // Mobile dots are pre-rendered in liquid (<li data-slider-indicator><a ...></a></li>)
    // and we DO NOT rebuild them here. Rebuilding on every init/afterChange caused two bugs:
    //   (1) empty() wipes the pre-rendered <li>/<a> if the rebuild loop yields 0 items;
    //   (2) hide_single_dots() then removes the emptied <ul> entirely, because its <li>
    //       count is 0 ≤ 1 — mobile dots vanish.
    // Instead we only toggle active state on the existing <li>/<a> markup.
    function setMobileActiveDot($wrap, currentIndex) {
      var $section = $wrap.closest('[data-section-type="ona-slideshow"]');
      var $mobileUl = $section.find('[data-ona-slide-dots-mobile]');
      if (!$mobileUl.length) return;
      $mobileUl.children('li').each(function (i) {
        var $li = jQuery(this);
        var $a = $li.children('a');
        var isActive = i === currentIndex;
        $li.toggleClass('slick-active', isActive);
        if (isActive) {
          $li.attr('aria-selected', 'true');
          $a.attr('aria-current', 'true');
        } else {
          $li.removeAttr('aria-selected');
          $a.removeAttr('aria-current');
        }
      });
    }
    // Delegate clicks on mobile dots to slickGoTo. Bind once per section (idempotent
    // via namespaced off()+on()) so shopify:section:load re-runs don't stack handlers.
    function bindMobileDotClicks($wrap, $slider) {
      var $section = $wrap.closest('[data-section-type="ona-slideshow"]');
      var $mobileUi = $section.find('.slideshow__arrows--mobile');
      var $mobileUl = $section.find('[data-ona-slide-dots-mobile]');
      if ($mobileUi.length) {
        $mobileUi
          .off('click.ona-mobile-arrow')
          .on('click.ona-mobile-arrow', '[data-ona-slide-prev]', function (ev) {
            ev.preventDefault();
            $slider.slick('slickPrev');
          })
          .on('click.ona-mobile-arrow', '[data-ona-slide-next]', function (ev) {
            ev.preventDefault();
            $slider.slick('slickNext');
          });
      }
      if (!$mobileUl.length) return;
      $mobileUl
        .off('click.ona-mobile-dot')
        .on('click.ona-mobile-dot', 'a', function (ev) {
          ev.preventDefault();
          var index = parseInt(jQuery(this).attr('data-slide-number'), 10);
          if (!isNaN(index)) $slider.slick('slickGoTo', index);
        });
    }
    function setMobileActiveContent($section, index) {
      $section.find('.slideshow__text-content--mobile').each(function () {
        var $c = jQuery(this);
        $c.toggleClass('slideshow__text-content--mobile-active',
          parseInt($c.attr('data-ona-mobile-content-index'), 10) === index);
      });
    }
    function boot() {
      if (typeof jQuery === 'undefined' || typeof jQuery.fn === 'undefined' || !jQuery.fn.slick) {
        return setTimeout(boot, 100);
      }
      jQuery('[data-ona-slideshow]').each(function () {
        var $el = jQuery(this);
        if ($el.hasClass('slick-initialized')) return;
        var autorotate = $el.data('autorotate') === true || $el.data('autorotate') === 'true';
        var speed = parseInt($el.data('speed'), 10) || 5000;
        var $wrap = $el.closest('.slideshow-wrapper');
        var $section = $el.closest('[data-section-type="ona-slideshow"]');
        bindMobileDotClicks($wrap, $el);
        $el.on('init.onaSlideshow', function () {
          setMobileActiveDot($wrap, 0);
          setMobileActiveContent($section, 0);
        });
        $el.on('afterChange.onaSlideshow', function (_e, _slick, current) {
          setMobileActiveDot($wrap, current);
          setMobileActiveContent($section, current);
        });
        $el.slick({
          autoplay: autorotate,
          autoplaySpeed: speed,
          dots: true,
          arrows: true,
          prevArrow: $wrap.find('[data-ona-slide-prev]'),
          nextArrow: $wrap.find('[data-ona-slide-next]'),
          appendDots: $wrap.find('[data-ona-slide-dots]'),
          fade: true,
          speed: 500,
          pauseOnHover: true
        });
        // init event already fired setMobileActiveDot(0); no post-init rebuild needed.
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
